export default __webpack_public_path__ + "images/deepecho_icon_dark.e01da110e61f74d8e8b8d4dcc0ec575f.png";